<template>
  <div class="max_box">
    <div data-v-b8fb3c5c="" class="recent-games">


        <div data-v-b04cd74c="" class="head">
          <div></div>
          <div data-v-b04cd74c="" class="head-text"> {{$t('会话')}} </div>
          <img data-v-b04cd74c="" src="/static/image/new/setting-icon.png" alt="" class="right">
        </div>


        <div data-v-9349a398="" class="PulldownRefresh">
            <div data-v-9349a398="" class="van-pull-refresh">
                <div class="van-pull-refresh__track" style="transition-duration: 0ms;">
                    <div class="van-pull-refresh__head" style="height: 80px;"></div>
                    <div data-v-9349a398="" class="main_content">
                        <div class="gameliostss">
                            <div class="gameliostssinner">
                                <div class="accounts-list" @click="$parent.goNav('/message')">
                                  <div class="accounts-swipe-cell">
                                    <img src="/static/image/new/kefu-logo1.png">
                                    <div class="accounts-list-right">
                                      <div class="nttitle">{{ $t('公告通知') }}
                                        <img src="/static/image/new/vip-icon.png" />
                                      </div><span class="rednum">1</span><br><span class="lastContent">
                                                {{ $t('上下分如有问题请及时联系客服') }}</span>
                                    </div>
                                  </div>
                                </div>
                                <div class="accounts-list" @click="kefu">
                                    <div class="accounts-swipe-cell">
                                      <img src="/static/image/new/kefu-logo2.png">
                                        <div class="accounts-list-right">
                                            <div class="nttitle"> {{ $t('在线客服') }}
                                            <img src="/static/image/new/vip-icon.png" />
                                            </div><!----><span class="lastContent">{{ $t('提供各类问题疑难排解') }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="accounts-list" @click="opIframe('https://t.me/s6top')">
                                    <div class="accounts-swipe-cell">
                                      <img src="/static/image/new/kefu-logo3.png">
                                        <div class="accounts-list-right">
                                            <div class="nttitle"> {{ $t('Telegram客服') }}
                                              <img src="/static/image/new/vip-icon.png" />
                                            </div><!----><span class="lastContent">{{ $t('提供各类问题疑难排解') }}</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="accounts-scroll"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>
  <script>
//
import {translateText} from "../common/utils";

export default {
  name: 'Foot',
  data() {
    return {
      url: ''
    }
  },
  methods: {
    async showTost(type = 0, title) {
      const message = await translateText([title]);
      this.$parent.showTost(type, message[0]);
    },
    getservicerurl() {
      let that = this;
      // this.$parent.showLoading();
      that.$apiFun.post('/api/getservicerurl', {}).then(res => {
        if (res.code != 200) {
          that.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.url = res.data.url;
        }
        // this.$parent.hideLoading();
      }).catch(() => {
        // this.$parent.hideLoading();
      });
    },
    kefu(){
      this.$parent.openKefu();
        // window.open(this.url, '_blank');
    },
    opIframe(url) {
      // window.open(url, '_blank');
      window.location.href = url
      // this.$parent.openKefu2();

      // this.$parent.goNav(`/kefu`);
    },
  },

  mounted() {
    this.getservicerurl()
    // initGameIframe 设置一秒的预加载时间
    setTimeout(() => {
    }, 1000)
    if(this.$store.state.userInfo.youxi_token) {
      this.$parent.initGameIframe()
    }
  },
  watch: {},
};
</script>

<style lang="scss" scoped>

.recent-games {
    width: 100%;
    height: 100%;
    overflow: hidden;
    background-color: #000;
    position: fixed;
    top: 0;
    left: 0;
    color: #FFFFFF;
    padding-bottom: 1.79rem;  // 底部导航栏高度
    font-family: PingFang SC;
}

.recent-games .gameliostss {
    width: 100%;
    height: calc(100% - 2.53333rem);
    scrollbar-width: none;
    -ms-overflow-style: none;
    overflow-x: hidden;
    overflow-y: scroll
}

.recent-games .gameliostss::-webkit-scrollbar {
    display: none;
    width: 0;
    background: transparent
}

.recent-games .gameliostss .gameliostssinner {
    width: 100%;
    padding: 0 .4rem .26rem;
    margin-bottom: 2.66667rem
}

.recent-games .accounts-scroll {
    width: 100%;
    overflow-x: scroll;
    overflow-y: scroll
}

.recent-games .accounts-list {
    border: .03rem solid rgba(255, 255, 255, 0.10);
    background: rgba(255, 255, 255, 0.10);
    border-radius: .19rem;
    height: 1.79rem;
    margin-bottom: .27rem;
    overflow: hidden;
}

.recent-games .accounts-list,
.recent-games .accounts-list .van-swipe-cell,
.recent-games .accounts-list .van-swipe-cell__wrapper {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    width: 100%
}

.recent-games .accounts-list .van-swipe-cell__right {
    height: 1.86667rem;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex
}

.recent-games .accounts-list .accounts-swipe-cell {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    padding: 0 .27rem;
}

.recent-games .accounts-list .accounts-swipe-cell img {
    width: 1.04rem;
    height: 1.04rem;
    margin-right: .27rem;
}

.recent-games .accounts-list .accounts-swipe-cell .accounts-list-right {
    width: 8rem;
    margin: 0 0;
    font-size: .32rem;
    color: #424653;
    font-weight: 700;
    position: relative
}

.recent-games .accounts-list .accounts-swipe-cell .accounts-list-right .nttitle {
    width: 100%;
}

.recent-games .accounts-list .accounts-swipe-cell .accounts-list-right .nttitle,
.recent-games .accounts-list .accounts-swipe-cell .accounts-list-right .nttitle div {
    float: left;
    color: #fff;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: .32rem;
}

.recent-games .accounts-list .accounts-swipe-cell .accounts-list-right .nttitle div {
    width: 50%;
    height: .37333rem
}

.recent-games .accounts-list .accounts-swipe-cell .accounts-list-right .nttitle div:nth-child(2) {
    -webkit-box-pack: end;
    -webkit-justify-content: flex-end;
    -ms-flex-pack: end;
    justify-content: flex-end;
    font-size: .26667rem;
    color: #7e88ad;
    font-weight: 400
}

.recent-games .accounts-list .accounts-swipe-cell .accounts-list-right .nttitle img {
    width: 0.35rem;
    height: 0.35rem;
    margin-left: .16rem;
}

.recent-games .accounts-list .accounts-swipe-cell .accounts-list-right span {
    font-size: .32rem;
    zoom: .84;
    color: #7e88ad;
    height: .32rem;
    margin-top: .1rem;
    font-weight: 500
}

.recent-games .accounts-list .accounts-swipe-cell .accounts-list-right .lastContent {
    float: left;
    width: 90%;
    overflow: hidden;
    font-size: 0.27rem;
    color: #8C8C8C;
    white-space: nowrap;
    text-overflow: ellipsis;
    text-align: left
}

.recent-games .accounts-list .accounts-swipe-cell .accounts-list-right .accounts-list-text02 {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: start;
    -webkit-justify-content: flex-start;
    -ms-flex-pack: start;
    justify-content: flex-start;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    width: 7.68rem;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis
}

.recent-games .delete-button,
.recent-games .van-button--danger {
    background-color: #ea4e3d;
    border: .02667rem solid #ea4e3d
}

.recent-games .delete-button {
    height: 100%
}

.recent-games .cancel-button {
    height: 100%;
    background-color: #c7c7cb;
    border: .02667rem solid #c7c7cb;
    color: #fff
}

.recent-games .rednum {
    float: right;
    width: .43rem;
    height: .43rem !important;

    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    right: .26667rem;
    top: .2rem;
    font-family: Gilroy, Gilroy;
    font-weight: bold;
    font-size: 0.29rem !important;
    background: #5884ff;
    color: #fff !important;
    position: absolute;
}


.recent-games .head {
    height: 1.17rem;
    padding: 0 .4rem;
    display: flex;
    align-items: center;
    justify-content: space-between
}

.recent-games .head img[data-v-b04cd74c] {
    height: .88rem;
    border-radius: .53333rem
}

.recent-games .head .head-text {
    font-size: 0.48rem;
    font-weight: 600
}

.recent-games .head .onlinepng[data-v-b04cd74c] {
    margin-left: 3.06667rem;
    width: .66667rem;
    height: .66667rem;
    margin-top: .26667rem
}

.recent-games .head .right[data-v-b04cd74c] {
    width: .64rem;
    height: .64rem;
    border-radius: 0
}
</style>



// WEBPACK FOOTER //
// src/components/dialogue.vue